import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../graphql/generated/graphql';
import type { DrugConfig, DrugProgram } from '../../types/drug-config';

export const getDrugConfigByMedication = (
    drugProgram: DrugProgram,
    medication:
        | AuthorizedMedicationInfoFragment
        | MedicationInfoFragment
        | UnknownMedicationInfoFragment
        | undefined
): DrugConfig | undefined => {
    if (!medication) {
        return undefined;
    }

    const ndc =
        medication.__typename === 'UnknownMedication'
            ? medication.originalNdc || medication.id
            : medication.id;

    return getDrugConfigByNdc(drugProgram, ndc);
};

export const getDrugConfigByNdc = (
    drugProgram: DrugProgram,
    ndc: string | undefined
): DrugConfig | undefined => {
    if (!ndc) {
        return undefined;
    }

    return drugProgram.drugConfigs.find((config) =>
        config.ndcDefinitions.some((x) => x.ndc === ndc)
    );
};
